import { useEffect, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSiteConfig } from '@/stores/siteConfigStore';

/** Wraps the login page and the customer / doctor portals: when the lab turned the login off, the whole area sends visitors home. */
const LoginGate = ({ children }: { children: ReactNode }) => {
  const loginEnabled = useSiteConfig((state) => state.loginEnabled);
  const load = useSiteConfig((state) => state.load);

  useEffect(() => {
    void load();
  }, [load]);

  if (loginEnabled === null) return null;
  if (!loginEnabled) return <Navigate to="/" replace />;
  return <>{children}</>;
};

export default LoginGate;
